import { useTranslation } from 'react-i18next'
import { Badge } from 'ui/src/components/Badge/Badge'
import { Text } from 'ui/src/components/Text/Text'
import { xStack } from 'ui/src/patterns/stack'
import { badge, card } from './FetchedInsuranceCard.css'

type Props = {
  insuranceCompany: string
  hasFetchedInsurances: boolean
}

export function FetchedInsuranceCard({ insuranceCompany, hasFetchedInsurances }: Props) {
  const { t } = useTranslation('purchase-form')

  return (
    <div className={card}>
      <header className={xStack({ justifyContent: 'space-between', gap: 'xs' })}>
        <Text>{insuranceCompany}</Text>
        <Badge className={badge} size="medium">
          {t('MATCHED_INSURANCE_CARD_BADGE')}
        </Badge>
      </header>

      <section>
        <Text size="xs" color="textSecondary">
          {hasFetchedInsurances
            ? t('CURRENT_INSURANCE_FIELD_DEFAULT_DISPLAY_ITEM')
            : t('CURRENT_INSURANCE_FETCH_FAILED_MESSAGE', { externalInsurerName: insuranceCompany })}
        </Text>
      </section>
    </div>
  )
}
